import { FC, useState } from "react"
import { Send } from "lucide-react"

const EngagementChatInput: FC = () => {
  const [message, setMessage] = useState("")

  return (
    <div className="w-full bg-white p-3 flex items-center rounded">
      <textarea
        className="appearance-none block w-full px-5 border-none focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm cursor-text resize-none"
        rows={1}
        value={message}
        onChange={e => setMessage(e.target.value)}
        disabled
      />
      <div className="px-4">
        <Send color="#786ff6" size={18} className="cursor-pointer" />
      </div>
    </div>
  )
}

export default EngagementChatInput
